import React, {useEffect} from 'react';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {UserApi} from '../../scaffold';
import useAuth from '../../utils/AuthContext';
import {useHistory} from 'react-router-dom';
import {Button, Card, Divider, message, Space} from 'antd';
import AppSideLayout from '../../components/layouts/AppSideLayout';
import PersonalApproveTable from '../../components/user/PersonalApproveTable';
import Flex from '../../components/Flex';
import Text from 'antd/lib/typography/Text';

export default function ProfileDetailPage() {
  const findHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userFindGet);
  const history = useHistory();
  const auth = useAuth();
  useEffect(() => {
    if (auth.currentUser) findHook.requestSync({id: auth.currentUser?.id || 0});
  }, [auth.currentUser]);
  return (
    <AppSideLayout title={'个人信息'}>
      <Card style={{flex: 1}} title={'个人信息'} loading={findHook.loading}>
        {findHook.data && (
          <div>
            <Flex>
              <Space>
                <Text strong>会员有效期:</Text>
                <Text>
                  {findHook.data.memberExpiredTime?.includes('2000-01-01') && (
                    <Space>
                      <span>未缴费</span>
                      <Button type={'primary'} onClick={() => history.push('/profile/payment')}>
                        立即缴费
                      </Button>
                    </Space>
                  )}
                  {findHook.data.memberExpiredTime?.includes('2099') && <span>永久</span>}
                  {!findHook.data.memberExpiredTime?.includes('2099') && !findHook.data.memberExpiredTime?.includes('2000') && (
                    <Space>
                      <span>{findHook.data.memberExpiredTime}</span>
                      <Button type={'primary'} onClick={() => history.push('/profile/payment')}>
                        立即缴费
                      </Button>
                    </Space>
                  )}
                </Text>
              </Space>
            </Flex>
            <Divider />
            <PersonalApproveTable approve={findHook.data.personalApprove} readonly />
          </div>
        )}
        {!auth.currentUser && <div>请先登录</div>}
      </Card>
    </AppSideLayout>
  );
}
